module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHKADAAQAAAABAAAAHAAAAABkvfSiAAAA70lEQVRIDe2WMQoCMRBF/4QtLKy2EAQbT2ApdnbexlLwBIKll/AMdnZi6QlsBMHCysJCiPlhAxYLITKbKtPskkn+2/nZ4gtcTXd29HljC4u5BYZc0yoB7hAcqx5W56XcpIFdrEWtBWnTEcHTQScVJyNsNgbWC2DQb9v+/9rjBWwOwOmKmixDGynXBYy6HIDavhzLhDvTnqxB+EfQJsv8NnK8F6C6y8XSYmmyA+WnSbYsdqBYGnMouV8sTbYsdiC/pT43us9iuuqqgjZZhiGVIEa50NAEh5joNR0rexA2jN9MxC4Z74O9mhNSk9pkkPUF4/pD7qo7yvwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/QuickSales/cancel.png
// module id = P4oo
// module chunks = 19